import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react'
import { useState } from 'react'
import { Card, Input, Segmented, Space, Typography, Button } from 'antd'
import { CodeOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons'

const { Text } = Typography

/**
 * In-editor UI for the raw-HTML block: a code textarea plus a live preview.
 * contentEditable is disabled so ProseMirror treats the block as opaque.
 */
export function RawHtmlView({ node, updateAttributes, deleteNode, selected }: NodeViewProps) {
  const [mode, setMode] = useState<'code' | 'preview'>('code')
  const html = (node.attrs.html as string) || ''

  return (
    <NodeViewWrapper
      className="blog-raw-html"
      contentEditable={false}
      style={{ margin: '12px 0' }}
    >
      <Card
        size="small"
        style={{
          borderColor: selected ? '#1e3a5f' : '#e5e7eb',
          background: '#fafafa',
        }}
        styles={{ body: { padding: 12 } }}
        title={
          <Space size={6}>
            <CodeOutlined />
            <Text style={{ fontSize: 13 }}>Raw HTML</Text>
          </Space>
        }
        extra={
          <Space size={8}>
            <Segmented
              size="small"
              value={mode}
              onChange={(v) => setMode(v as 'code' | 'preview')}
              options={[
                { value: 'code', icon: <CodeOutlined /> },
                { value: 'preview', icon: <EyeOutlined /> },
              ]}
            />
            <Button
              size="small"
              danger
              type="text"
              icon={<DeleteOutlined />}
              onClick={() => deleteNode()}
            />
          </Space>
        }
      >
        {mode === 'code' ? (
          <Input.TextArea
            value={html}
            onChange={(e) => updateAttributes({ html: e.target.value })}
            placeholder="<div>Zalepite HTML/CSS ovde…</div>"
            autoSize={{ minRows: 4, maxRows: 20 }}
            style={{ fontFamily: 'monospace', fontSize: 13 }}
          />
        ) : (
          <div
            className="blog-raw-html-preview"
            // Trusted staff content; sanitized server-side on save.
            dangerouslySetInnerHTML={{ __html: html || '<em>Nema sadržaja</em>' }}
          />
        )}
      </Card>
    </NodeViewWrapper>
  )
}
